<script>
    import TagAtom from "./TagAtom.svelte";
    export let color = "default";
    export let fill = "solid";
    export let round = false;
    const colorMaps = {
        default: "#666666",
        primary: "var(--sui-color-primary, #1677ff)",
        success: "var(--sui-color-success, #00b578)",
        warning: "var(--sui-color-warning, #ff8f1f)",
        danger: "var(--sui-color-danger, #ff3141)",
    };
    let rColor;
    let tColor;
    let bColor;
    $: {
        rColor = colorMaps[color] || color;
        tColor = fill === "solid" ? "#fff" : rColor;
        bColor = fill === "solid" ? rColor : "transparent";
    }
</script>

<TagAtom
    --tag-border-color={rColor}
    --tag-text-color={tColor}
    --tag-background-color={bColor}
    class={`${round ? "round" : ""}`}
>
    <slot />
</TagAtom>

<style lang="less">
    @import "./tag.less";
</style>
